import React from 'react'
import { Popover, Typography } from '@mui/material'

const PopoverCustom = ({ id, open, anchorEl, onClose, text }) => (
  <Popover
    aria-hidden={false}
    id={`${id}-${text}`}
    sx={{ pointerEvents: 'none' }}
    open={open}
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: 'center',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: -14,
      horizontal: 'center',
    }}
    onClose={onClose}
    disableRestoreFocus>
    <Typography
      sx={theme => ({
        p: 0,
        px: '4px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 11,
      })}>
      {text}
    </Typography>
  </Popover>
)
export default PopoverCustom
